var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"form-item-tip"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }